// extracted by mini-css-extract-plugin
export var body = "TextWithImage-module--body--Rokek";
export var image = "TextWithImage-module--image--jWcXn";
export var reverse = "TextWithImage-module--reverse--ODoNf";
export var root = "TextWithImage-module--root--PgoMs";
export var text = "TextWithImage-module--text--6LxsF";
export var withLine = "TextWithImage-module--withLine--1AFCv";